import { defineConfig, createSystem, defaultConfig } from '@chakra-ui/react';
export { ChakraProvider } from '@chakra-ui/react';

// src/theme/index.ts

// src/theme/colors.ts
var brandColors = {
  primary: "#4CAF50",
  primaryLight: "#81C784",
  primaryDark: "#388E3C",
  secondary: "#2196F3",
  accent: "#FF9800",
  success: "#4CAF50",
  warning: "#FF9800",
  error: "#F44336",
  info: "#2196F3"
};

// src/theme/tokens.ts
var spacing = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  10: 40,
  12: 48,
  16: 64,
  20: 80,
  24: 96
};
var radii = {
  none: "0px",
  sm: "4px",
  md: "8px",
  lg: "12px",
  xl: "16px",
  "2xl": "24px",
  full: "9999px"
};
var fontSizes = {
  xs: "0.75rem",
  // 12px
  sm: "0.875rem",
  // 14px
  md: "1rem",
  // 16px
  lg: "1.125rem",
  // 18px
  xl: "1.25rem",
  // 20px
  "2xl": "1.5rem",
  // 24px
  "3xl": "1.875rem",
  // 30px
  "4xl": "2.25rem",
  // 36px
  "5xl": "3rem"
  // 48px
};
var fontWeights = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
};
var lineHeights = {
  none: 1,
  tight: 1.25,
  snug: 1.375,
  normal: 1.5,
  relaxed: 1.625,
  loose: 2
};
var zIndices = {
  hide: -1,
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  toast: 1600,
  tooltip: 1700
};
var durations = {
  fast: "150ms",
  normal: "200ms",
  slow: "300ms",
  slower: "400ms"
};
var easings = {
  default: "cubic-bezier(0.4, 0, 0.2, 1)",
  linear: "linear",
  in: "cubic-bezier(0.4, 0, 1, 1)",
  out: "cubic-bezier(0, 0, 0.2, 1)",
  inOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  spring: "cubic-bezier(0.175, 0.885, 0.32, 1.275)"
};
var breakpoints = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px"
};
var customConfig = defineConfig({
  theme: {
    tokens: {
      colors: {
        // Brand colors
        brand: {
          50: { value: "#E8F5E9" },
          100: { value: "#C8E6C9" },
          200: { value: "#A5D6A7" },
          300: { value: "#81C784" },
          400: { value: "#66BB6A" },
          500: { value: "#4CAF50" },
          600: { value: "#43A047" },
          700: { value: "#388E3C" },
          800: { value: "#2E7D32" },
          900: { value: "#1B5E20" }
        },
        // Mood colors
        mood: {
          joyful: { value: "#FFD93D" },
          content: { value: "#6BCB77" },
          neutral: { value: "#9E9E9E" },
          melancholic: { value: "#4D96FF" },
          anxious: { value: "#FF6B6B" },
          excited: { value: "#FF9F43" },
          grateful: { value: "#A78BFA" },
          nostalgic: { value: "#F472B6" }
        }
      },
      fonts: {
        heading: { value: '"Inter", system-ui, sans-serif' },
        body: { value: '"Inter", system-ui, sans-serif' }
      },
      radii: {
        card: { value: "16px" },
        button: { value: "12px" },
        input: { value: "8px" }
      },
      spacing: {
        safe: { value: "env(safe-area-inset-bottom, 0px)" }
      }
    },
    semanticTokens: {
      colors: {
        // Background colors
        "bg.primary": {
          value: { _light: "{colors.white}", _dark: "{colors.gray.900}" }
        },
        "bg.secondary": {
          value: { _light: "{colors.gray.50}", _dark: "{colors.gray.800}" }
        },
        "bg.muted": {
          value: { _light: "{colors.gray.100}", _dark: "{colors.gray.700}" }
        },
        // Text colors
        "text.primary": {
          value: { _light: "{colors.gray.900}", _dark: "{colors.white}" }
        },
        "text.secondary": {
          value: { _light: "{colors.gray.600}", _dark: "{colors.gray.400}" }
        },
        "text.muted": {
          value: { _light: "{colors.gray.500}", _dark: "{colors.gray.500}" }
        },
        // Border colors
        "border.default": {
          value: { _light: "{colors.gray.200}", _dark: "{colors.gray.700}" }
        },
        "border.muted": {
          value: { _light: "{colors.gray.100}", _dark: "{colors.gray.800}" }
        }
      }
    }
  }
});
var system = createSystem(defaultConfig, customConfig);

export { brandColors, breakpoints, durations, easings, fontSizes, fontWeights, lineHeights, radii, spacing, system, zIndices };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map